import { render, staticRenderFns } from "./trafficOrderInfo.vue?vue&type=template&id=2a09b686&"
import script from "./trafficOrderInfo.vue?vue&type=script&lang=ts&"
export * from "./trafficOrderInfo.vue?vue&type=script&lang=ts&"
import style0 from "./trafficOrderInfo.vue?vue&type=style&index=0&lang=less&"
import style1 from "./trafficOrderInfo.vue?vue&type=style&index=1&lang=less&scopde=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports